import * as React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { SearchResult, SearchSection } from './UniversalSearch';
import ThemeObject, { Theme } from 'helpers/theme';
import { ScaleLoader } from 'react-spinners';
import UserResult from './UserResult';

const useStyles = createUseStyles((theme: Theme) => ({
  results: {
    borderTop: '1px solid #ededed',
    padding: '4px 10px 10px',
    maxHeight: 'min(56vh, 620px)',
    overflowY: 'auto',
    background: 'white'
  },
  sectionHeader: {
    fontWeight: 500,
    fontSize: 12,
    color: theme.colors.secondaryGrey,
    padding: '12px 10px 5px'
  },
  empty: {
    padding: '26px 10px 20px',
    textAlign: 'center',
    fontSize: 13,
    color: theme.colors.secondaryGrey
  },
  loader: {
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  }
}));

type Props = {
  sections: SearchSection[];
  loading: boolean;
  query: string;
  onSelect: (result: SearchResult) => void;
  highlighted: number;
  onHighlight: (index: number) => void;
};

function UserResults({
  sections,
  loading,
  query,
  onSelect,
  highlighted,
  onHighlight
}: Props) {
  const theme = useTheme();
  const classes = useStyles({ theme });

  if (loading) {
    return (
      <div className={classes.results}>
        <div className={classes.loader}>
          <ScaleLoader
            color={ThemeObject.colors.borderGrey}
            height={20}
            loading={loading}
          />
        </div>
      </div>
    );
  }

  let index = -1;
  return (
    <div className={classes.results} data-results-scroller>
      {sections.length === 0 && (
        <div className={classes.empty}>
          {query.length > 0 ? `No results for “${query}”` : 'No results found'}
        </div>
      )}
      {sections.map((section) => (
        <div key={section.label}>
          <div className={classes.sectionHeader}>{section.label}</div>
          {section.results.map((result) => {
            index += 1;
            const resultIndex = index;
            return (
              <UserResult
                result={result}
                icon={section.icon}
                onClick={onSelect}
                highlighted={resultIndex === highlighted}
                onHover={() => onHighlight(resultIndex)}
                key={result.uuid}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}

export default UserResults;
